var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"text-base font-medium text-gray-700 mb-1 text-center"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"bg-gray-50 border border-gray-200 rounded-xl p-4 text-sm",domProps:{"innerHTML":_vm._s(_vm.getStatus())}})])
}
var staticRenderFns = []

export { render, staticRenderFns }